const verifyUserObject = 'verifyUserObject'

const verifyUserLocalStorage = {
	setVerifyUserObject: (userObject) => {
		global.localStorage.setItem(verifyUserObject, JSON.stringify(userObject))
	},
	getVerifyUserObject: () => JSON.parse(global.localStorage.getItem(verifyUserObject)),
	removeVerifyUserObject: () => {
		global.localStorage.removeItem(verifyUserObject)
	}
}

export default verifyUserLocalStorage



// WEBPACK FOOTER //
// ./src/dataservices/verifyUserLocalStorage.js